// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"337":"6aef74bfaf04e35a","2875":"6d95cda3df23bcd0","4486":"3c1d456a4066fec4"}[chunkId] + ".js";
};